import { HttpEvent, HttpHandler, HttpInterceptor, HttpProgressEvent, HttpRequest } from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable()
export class HttpProgressInterceptor implements HttpInterceptor {

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.reportProgress) {
      // only intercept when the request is configured to report its progress
      return next.handle(req).pipe(
        tap((_event: HttpEvent<HttpProgressEvent>) => {
        })
      );
    } else {
      return next.handle(req);
    }
  }
}
